import React, { useState, useRef, useEffect } from 'react';

interface InputFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  width?: string;
  height?: string;
  size?: 'small' | 'medium' | 'large';
  type?: 'text' | 'email' | 'password' | 'number' | 'date' | 'time' | 'datetime-local';
  label?: string;
  required?: boolean;
  iconImage?: string; // 아이콘 이미지 추가
  completeText?: string; // 완료 텍스트 추가
  CorrectAlarmText?: string; // 알림 텍스트 추가
  IncorrectAlarmText?: string; // 알림 텍스트 추가
}

const InputField: React.FC<InputFieldProps> = ({
  value,
  onChange,
  placeholder = '입력하세요',
  disabled = false,
  width,
  height,
  size = 'medium',
  type = 'text',
  label,
  required = false,
  iconImage,
  completeText,
  CorrectAlarmText,
  IncorrectAlarmText
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  
  const sizeConfig = {
    small: { width: '352px', height: '40px', fontSize: '13px' },
    medium: { width: '352px', height: '48px', fontSize: '14px' },
    large: { width: '360px', height: '56px', fontSize: '16px' }
  };
  
  // size가 제공되면 sizeConfig 사용, 그렇지 않으면 수동 설정 사용
  const finalWidth = width || sizeConfig[size].width;
  const finalHeight = height || sizeConfig[size].height;
  const fontSize = sizeConfig[size].fontSize;

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div style={{
      width: finalWidth,
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* 라벨 */}
      {label && (
        <label style={{
          fontSize: '14px',
          fontWeight: '500',
          color: '#161616',
          marginBottom: '8px'
        }}>
          {label}
          {required && <span style={{ color: '#FF6F0F', marginLeft: '4px' }}>*</span>}
        </label>
      )}

      {/* 입력 필드 */}
      <div style={{
        position: 'relative',
        width: '100%',
        height: finalHeight,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '8px'
      }}>
        <input
          ref={inputRef}
          type={type}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          style={{
            width: '100%',
            height: finalHeight,
            padding: '12px 16px',
            fontSize: fontSize,
            color: disabled ? '#989898' : '#161616',
            backgroundColor: disabled ? '#F5F5F5' : 'white',
            border: `1.2px solid ${disabled ? '#E0E0E0' : (isFocused ? '#161616' : '#F0F0F0')}`,
            borderRadius: '8px',
            transition: 'all 0.2s ease',
            cursor: disabled ? 'not-allowed' : 'text',
            opacity: disabled ? 0.6 : 1,
            outline: 'none',
            boxSizing: 'border-box',
            fontFamily: 'Pretendard, sans-serif',
            fontWeight: '400',
            lineHeight: '1.5',
            // 날짜/시간 입력 필드 스타일 (index.css에서 기본 스타일 상속)
            colorScheme: 'light',
            WebkitAppearance: 'none',
            MozAppearance: 'textfield'
          } as React.CSSProperties}
          className="input-field-placeholder"
        />
        {/* 아이콘 이미지 */}
        {iconImage && (
          <img src={iconImage} alt="아이콘" style={{ width: '24px', height: '24px' }} />
        )}
        {/* 완료 텍스트 */}
        {completeText && (
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#161616' }}>{completeText}</span>
        )}

      </div>

      {/* 알림 텍스트 */}
      {CorrectAlarmText && (
        <span style={{ 
          padding: '8px 8px 0px 8px', 
          fontSize: '12px', 
          fontWeight: '500', 
          color: '#161616' 
        }}>{CorrectAlarmText}</span>
      )}
      {IncorrectAlarmText && (
        <span style={{ 
          padding: '8px 8px 0px 8px', 
          fontSize: '12px', 
          fontWeight: '500', 
          color: '#FF3838' 
        }}>{IncorrectAlarmText}</span>
      )}
    </div>
  );
};

export default InputField;  